import React from 'react';
import {
  Typography,
  TypographyComponentEnum,
  TypographyVariant,
} from '@unisporkal/alliance-ui';
import cx from 'classnames';
import styles from './AcquisitionTitle.module.scss';

interface SimpleTitleModalProps {
  title: string;
}

const SimpleTitleModal: React.FC<SimpleTitleModalProps> = ({ title }) => (
  <div
    className={cx(
      styles.simpleCenteredTitleContainer,
      styles.simpleTitleUppercase
    )}
    data-testid="simple-title-container"
  >
    <Typography
      variant={TypographyVariant.title.medium}
      component={TypographyComponentEnum.H6}
      className={styles.title}
    >
      {title}
    </Typography>
  </div>
);

export default SimpleTitleModal;
